import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { ConfirmationModal } from '@/shared/components';
import { RenderNewButtonDeleteOptions } from '@/shared/lib/forms/form-wrapper.types';
import { Text } from '@/shared/uikit/Text';
import { Button } from '@/shared/uikitV2/Button';

type FormDeleteConfirmationModalProps = {
  isOpen: boolean;
  onDeleteClick: () => void;
  onConfirmDeleteClick: () => void;
  onCancelDeleteClick: () => void;
  deleteOptions: RenderNewButtonDeleteOptions;
};

export const FormDeleteConfirmationModal: FC<FormDeleteConfirmationModalProps> = ({
  isOpen,
  onCancelDeleteClick,
  onConfirmDeleteClick,
  onDeleteClick,
  deleteOptions,
}) => {
  const { t } = useTranslation(['forms_assets']);

  return (
    <DeleteButtonWrapper>
      <Button type="text" style={{ cursor: 'pointer' }} onClick={onDeleteClick}>
        {t(deleteOptions.texts.button)}
      </Button>
      <ConfirmationModal
        destroyOnClose
        open={isOpen}
        cancelText={t(deleteOptions.texts.cancel)}
        onCancel={onCancelDeleteClick}
        okText={t(deleteOptions.texts.ok)}
        onOk={onConfirmDeleteClick}
      >
        <Text>{t(deleteOptions.texts.description)}</Text>
      </ConfirmationModal>
    </DeleteButtonWrapper>
  );
};

const DeleteButtonWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`;
